import { defaultManufacturers } from './default-manufacturers-de.i18n';

export const de = {
  defaultManufacturers,
};
